const CONTRACT_PROFILE_TEST_EMAIL = "relibuild028@gmail.com";
const CONTRACT_PROFILE_TEST_DOMAIN = "@thetradesmens.com";

export const isContractProfileTestUserEmail = (email?: string | null) => {
  const normalizedEmail = String(email || "").trim().toLowerCase();

  return normalizedEmail === CONTRACT_PROFILE_TEST_EMAIL
    || normalizedEmail.endsWith(CONTRACT_PROFILE_TEST_DOMAIN);
};
